import styled, { css, DefaultTheme } from 'styled-components';
import { Icon } from '../../icon';
import { memoizeFunction } from '@agilepoint/utils-common';
import { DropdownState } from '../theme';

const getDropdownArrowStylesByState = memoizeFunction((state: DropdownState) => {
  const getStyles = (theme: DefaultTheme) => {
    const { dropdown: { colors } } = theme;
    return colors[state];
  };
  return css`
      fill: ${({ theme }) => getStyles(theme).iconColor};
  `;
});

export const DropdownArrow = styled(Icon).attrs(() => ({
  className: String('ap-dropdown-arrow')
})) <{ $showOptions?: boolean, $disabled?: boolean, $error?: boolean }>`
  transition: all .25s ease-in-out;
  transform: ${({ $showOptions }) => ($showOptions ? 'none' : 'rotate(180deg)')};
  ${({ $disabled, $error }) => ($disabled ? getDropdownArrowStylesByState('disabled') : ($error ? getDropdownArrowStylesByState('error') : getDropdownArrowStylesByState('default')))};
  &:hover {
    ${({ $disabled, $error }) => ($disabled ? getDropdownArrowStylesByState('disabled') : ($error ? getDropdownArrowStylesByState('error') : getDropdownArrowStylesByState('hovered')))};

  }
  &:focus, :active {
    ${({ $disabled, $error }) => ($disabled ? getDropdownArrowStylesByState('disabled') : ($error ? getDropdownArrowStylesByState('error') : getDropdownArrowStylesByState('focused')))};

  }
`;
